import { ConfigurationResponse } from './models/configuration';
import { VirtualFileSystemType } from './models/files';
import {
  AuthorizedClients,
  Basis,
  Connected,
  IsacSession,
} from './models/session';
import { Inbox, Shares } from './services/share/ShareService';

export * from './models/files';
export * from './models/session';
export * from './models/space';

export const defaultState = {
  status: 'idle' as const,
  isLoggedIn: false,
  cypherCode: undefined,
  token: undefined,
  session: undefined as IsacSession | undefined,
  basis: undefined,
};

export interface UserData {
  basis: Basis;
  configuration: ConfigurationResponse;
  files: Partial<VirtualFileSystemType>;
  connected: Connected;
  authorizedClients: AuthorizedClients[];
  shares: Shares;
  inbox: Inbox;
}
